import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Single source of truth for global counters. All pages should import this
 * to avoid stale/hardcoded numbers that drift apart (e.g. "117+ GCCs" while
 * another page shows "1,191"). Read-once + cached for 60s.
 */
const CACHE = { data: null, fetchedAt: 0 };
const TTL_MS = 60_000;

export function useKarmStats() {
  const [stats, setStats] = useState(CACHE.data);

  useEffect(() => {
    const now = Date.now();
    if (CACHE.data && now - CACHE.fetchedAt < TTL_MS) {
      setStats(CACHE.data);
      return;
    }
    api.get("/stats/public").then((r) => {
      CACHE.data = r.data;
      CACHE.fetchedAt = Date.now();
      setStats(r.data);
    }).catch(() => {});
  }, []);

  return stats || { companies: 0, jobs: 0, sectors: 0, recent_jobs_7d: 0, companies_with_jobs: 0 };
}
